/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ property: NonNullable<unknown> }} Picker_PlaceholderInputs */

const en_picker_placeholder = /** @type {(inputs: Picker_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Change ${i?.property}`)
};

const de_picker_placeholder = /** @type {(inputs: Picker_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.property} ändern`)
};

/**
* | output |
* | --- |
* | "Change {property}" |
*
* @param {Picker_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const picker_placeholder = /** @type {((inputs: Picker_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_picker_placeholder(inputs)
	return en_picker_placeholder(inputs)
});